<template>
  <div class="list_box" @click="goDetail(item.id)">
    <div class="list_box_top">
      <img class="center_left_box" :src="item.meetingRoomImages" />
      <div class="center_right_box">
        <span class="center_right_title">{{item.meetingRoomName}}</span>
        <span class="center_right_area">面积{{item.area}}㎡ 座位{{item.meetingRoomNum}}人</span>
        <span class="center_right_address">{{item.address}}</span>
        <span class="price">
          <span>￥{{item.unitPrice | priceT}}</span> / 小时起
        </span>
      </div>
    </div>
    <div class="list_box_bottom" v-if="item.isOnlinePay">
      <div class="scale_box">
        <div class="scale_item" v-for="(mess,index) in item.amData" :key="index">
          <span class="number">{{index%2==0?index/2:''}}</span>
          <div :class="['scale_item_bottom',index == 24?'scale_item_bottom_no':'']">
            <span v-if="index%2==0" :class="['line_h',index==24?'line_h_last':'']"></span>
            <span v-if="index != 24" :class="['block',mess==1?'':'white']"></span>
            <span v-if="index%2==0 && index != 24" class="line"></span>
          </div>
        </div>
        <span class="time_am">AM</span>
      </div>
      <div class="scale_box">
        <span class="time_am time_pm">PM</span>
        <div class="scale_item" v-for="(mess,index) in item.pmData" :key="index">
          <span class="number">{{index%2==0?index/2+12:''}}</span>
          <div :class="['scale_item_bottom',index == 24?'scale_item_bottom_no':'']">
            <span v-if="index%2==0" :class="['line_h',index==24?'line_h_last':'']"></span>
            <span v-if="index != 24" :class="['block',mess==1?'':'white']"></span>
            <span v-if="index%2==0 && index != 24" class="line"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "roomItem",
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  filters: {
    priceT(val) {
      if (val) {
        return Number(val).toFixed(2);
      } else {
        return "0.00";
      }
    }
  },
  methods: {
    goDetail(id) {
      this.$router.push({
        path: `/roomDetail?id=${id}`
        // path: `/MeetingRoomSuccess`
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
/*-----------中间信息列表模块---------*/
.list_box {
  background: #fff;
  border-radius: 8px;
  margin: 20px;
  padding: 28px;
}

.list_box_top {
  display: flex;
  flex-direction: row;
}

.center_left_box {
  width: 216px;
  height: 162px;
  margin-right: 28px;
  //   border-radius: 8px;
  background: #d8d8d8;
}

.center_right_box {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
}

.centerRightTop {
  display: flex;
  flex-direction: column;
}

.centerRightTop span {
  display: block;
}

.center_right_title {
  width: 410px;
  height: 40px;
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 8px;
}

.center_right_area,
.center_right_address {
  height: 28px;
  font-size: 24px;
  color: rgba(153, 153, 153, 1);
  line-height: 28px;
  margin-bottom: 8px;
}

.center_right_address {
  width: 410px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.centerRightBottom {
  display: flex;
  flex-direction: row;
}

.price {
  height: 40px;
  font-size: 24px;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
}

.price span {
  font-size: 28px;
  color: #fc3f56;
}
/* 时间轴 */
.list_box_bottom {
  height: 164px;
  padding: 28px 0 8px;
}
.scale_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 68px;
  padding-left: 8px;
  margin-bottom: 14px;
  overflow: visible;
}
.scale_item {
  height: 68px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: visible;
}
.number {
  display: block;
  font-size: 24px;
  color: rgba(153, 153, 153, 1);
  line-height: 34px;
  margin-left: -5px;
}
.scale_item_bottom {
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  border-bottom: 2.1px solid #dadada;
  box-sizing: border-box;
}
.scale_item_bottom_no {
  border-bottom: 2.1px solid #fff;
}
.line_h {
  height: 30px;
  width: 2px;
  background: #dadada;
}
.line_h_last {
  margin-bottom: -2px;
  height: 32px;
}
.block {
  width: 22px;
  height: 18px;
  background: #dadada;
}
.white {
  background: #fff;
}
.line {
  width: 2px;
  height: 18px;
  background: #dadada;
}
.time_am {
  height: 68px;
  font-size: 24px;
  color: rgba(153, 153, 153, 1);
  line-height: 100px;
  flex: 1;
  text-align: right;
}
.time_pm {
  text-align: left;
}
</style>